var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "enterprise-set-main" },
    [
      _c("div", { staticClass: "option-li" }, [
        _c("div", { staticClass: "option-top" }, [
          _c("div", { staticClass: "options-title" }, [
            _c("img", {
              staticClass: "icon-style",
              attrs: { src: require("@/assets/img/bingding_icon.png"), alt: "" }
            }),
            _c("div", { staticClass: "title-text" }, [
              _c(
                "div",
                { staticClass: "flex" },
                [
                  _vm._v(" 容量管理 "),
                  _c("el-progress", {
                    staticClass: "capacity",
                    attrs: {
                      percentage: _vm.capacityData.percentage,
                      color: "rgb(128,128,255)",
                      "stroke-linecap": "butt",
                      "stroke-width": 8,
                      format: _vm.formatCapacity
                    }
                  }),
                  _c("span", { staticClass: "capacity-text" }, [
                    _vm._v(
                      _vm._s(_vm.capacityData.hasUse) +
                        "/" +
                        _vm._s(_vm.capacityData.total)
                    )
                  ])
                ],
                1
              )
            ]),
            _c(
              "div",
              {
                staticClass: "option-btn",
                on: {
                  click: function($event) {
                    return _vm.option(3)
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(!_vm.optionType3 ? "展开" : "收起"))
                ]),
                _c("i", {
                  staticClass: "btn-icon el-icon-caret-bottom",
                  class: _vm.optionType3 ? "btn-icon2" : ""
                })
              ]
            )
          ]),
          _vm._m(0)
        ]),
        _c(
          "div",
          {
            staticClass: "option-bottom",
            class: _vm.optionType3
              ? "option-bottom-open3"
              : "option-bottom-close"
          },
          _vm._l(_vm.capacityData.items, function(item, index) {
            return _c(
              "div",
              { key: index, staticClass: "flex capacity-item" },
              [
                _c("span", { staticClass: "capacity-item-point" }),
                _c("div", { staticClass: "capacity-item-label" }, [
                  _vm._v(_vm._s(item.label))
                ]),
                _c("div", { staticClass: "capacity-item-detail" }, [
                  _vm._v("已使用" + _vm._s(item.value))
                ])
              ]
            )
          }),
          0
        )
      ]),
      _c("div", { staticClass: "option-li" }, [
        _c("div", { staticClass: "option-top" }, [
          _c("div", { staticClass: "options-title" }, [
            _c("img", {
              staticClass: "icon-style",
              attrs: { src: require("@/assets/img/bingding_icon.png"), alt: "" }
            }),
            _c("div", { staticClass: "title-text" }, [
              _vm._v("绑定/解绑档案审批")
            ]),
            _c(
              "div",
              {
                staticClass: "option-btn",
                class: _vm.aprroveOpenStatus ? "" : "disable-open",
                on: {
                  click: function($event) {
                    return _vm.option(1)
                  }
                }
              },
              [
                _c("span", [_vm._v(_vm._s(!_vm.optionType ? "展开" : "收起"))]),
                _c("i", {
                  staticClass: "btn-icon el-icon-caret-bottom",
                  class: _vm.optionType ? "btn-icon2" : ""
                })
              ]
            )
          ]),
          _vm._m(1)
        ]),
        _c(
          "div",
          {
            staticClass: "option-bottom",
            class: _vm.optionType ? "option-bottom-open" : "option-bottom-close"
          },
          [
            _c(
              "el-checkbox-group",
              {
                on: { change: _vm.checkChange },
                model: {
                  value: _vm.checkList,
                  callback: function($$v) {
                    _vm.checkList = $$v
                  },
                  expression: "checkList"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "check-item",
                    class: _vm.checkList.includes("approveBindStatus")
                      ? "is-check"
                      : ""
                  },
                  [
                    _c(
                      "el-checkbox",
                      { attrs: { label: "approveBindStatus" } },
                      [
                        _c("div", { staticClass: "check-label-wrap" }, [
                          _c("span", { staticClass: "label-title" }, [
                            _vm._v("绑定档案需要通过审批")
                          ]),
                          _c("span", { staticClass: "label-tip" }, [
                            _vm._v("当客户已绑定1份档案之后的绑定均需要审批")
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "check-item",
                    class: _vm.checkList.includes("approveUnBindStatus")
                      ? "is-check"
                      : ""
                  },
                  [
                    _c(
                      "el-checkbox",
                      { attrs: { label: "approveUnBindStatus" } },
                      [
                        _c("div", { staticClass: "check-label-wrap" }, [
                          _c("span", { staticClass: "label-title" }, [
                            _vm._v("解绑档案需要通过审批")
                          ]),
                          _c("span", { staticClass: "label-tip" }, [
                            _vm._v("所有解绑均需要审批")
                          ])
                        ])
                      ]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "btn-wrap" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { plain: "", disabled: _vm.approveDisable },
                    on: { click: _vm.approveCancel }
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", disabled: _vm.approveDisable },
                    on: { click: _vm.approveSave }
                  },
                  [_vm._v("保存")]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "option-li" }, [
        _c("div", { staticClass: "option-top" }, [
          _c("div", { staticClass: "options-title" }, [
            _c("img", {
              staticClass: "icon-style",
              attrs: { src: require("@/assets/img/bingding_icon.png"), alt: "" }
            }),
            _c("div", { staticClass: "title-text" }, [_vm._v("标签同步")]),
            _c(
              "div",
              {
                staticClass: "option-btn",
                on: {
                  click: function($event) {
                    return _vm.option(5)
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(!_vm.optionType5 ? "展开" : "收起"))
                ]),
                _c("i", {
                  staticClass: "btn-icon el-icon-caret-bottom",
                  class: _vm.optionType5 ? "btn-icon2" : ""
                })
              ]
            )
          ]),
          _vm._m(2)
        ]),
        _c(
          "div",
          {
            staticClass: "option-bottom",
            class: _vm.optionType5
              ? "option-bottom-open"
              : "option-bottom-close"
          },
          [
            _c("div", {
              staticClass: "mask",
              class: _vm.isClick ? "maskShow" : "",
              on: { click: _vm.tipClick }
            }),
            _c(
              "el-button",
              {
                staticClass: "synchronization-btn",
                attrs: {
                  size: "small",
                  type: "primary",
                  disabled: _vm.isClick
                },
                on: { click: _vm.synchronization }
              },
              [_vm._v("客户标签同步")]
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "option-li" }, [
        _c("div", { staticClass: "option-top" }, [
          _c("div", { staticClass: "options-title" }, [
            _c("img", {
              staticClass: "icon-style",
              attrs: { src: require("@/assets/img/bingding_icon.png"), alt: "" }
            }),
            _c("div", { staticClass: "title-text" }, [_vm._v("删除好友预警")]),
            _c(
              "div",
              {
                staticClass: "option-btn",
                on: {
                  click: function($event) {
                    return _vm.option(6)
                  }
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(!_vm.optionType6 ? "展开" : "收起"))
                ]),
                _c("i", {
                  staticClass: "btn-icon el-icon-caret-bottom",
                  class: _vm.optionType6 ? "btn-icon2" : ""
                })
              ]
            )
          ]),
          _c(
            "div",
            {
              staticClass: "option-bottom",
              class: _vm.optionType6
                ? "option-bottom-open"
                : "option-bottom-close"
            },
            [
              _c("div", { staticClass: "notification-column" }, [
                _c(
                  "div",
                  {
                    staticClass: "operation-wrap",
                    on: { click: _vm.getEmployee }
                  },
                  [
                    _c("span", { staticClass: "explan-text" }, [
                      _vm._v("通知职员 ")
                    ]),
                    _c("el-input", {
                      staticStyle: { width: "240px" },
                      attrs: {
                        size: "small",
                        placeholder: "请选择",
                        readonly: ""
                      },
                      model: {
                        value: _vm.selectedEmployeeNum,
                        callback: function($$v) {
                          _vm.selectedEmployeeNum = $$v
                        },
                        expression: "selectedEmployeeNum"
                      }
                    })
                  ],
                  1
                )
              ]),
              !!_vm.searchMenNames.length
                ? _c(
                    "div",
                    { staticClass: "tag-wrap" },
                    _vm._l(_vm.searchMenNames, function(tag) {
                      return _c(
                        "el-tag",
                        {
                          key: tag.userId,
                          staticClass: "el-tag-class",
                          attrs: { type: "primary", size: "small" }
                        },
                        [_vm._v(" " + _vm._s(tag.name) + " ")]
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "btn-wrap" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        plain: "",
                        disabled: !_vm.searchMenNames.length
                      },
                      on: { click: _vm.cancel }
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.save } },
                    [_vm._v("保存")]
                  )
                ],
                1
              )
            ]
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "option-li" },
        [
          _c("el-button", { on: { click: _vm.handleDownload } }, [
            _vm._v("企微多开工具下载页面")
          ])
        ],
        1
      ),
      _c("StaffTree", {
        ref: "myStaffTree",
        attrs: {
          title: "选择成员",
          dialogVisibleTree: _vm.dialogVisibleTree,
          currentSelectMember: _vm.currentSelectMember
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "options-explain" }, [
      _c("span", { staticClass: "explan-text" }, [
        _vm._v("当空间容量不足，请立即联系客莱宝平台人员续费扩容。")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "options-explain" }, [
      _c("span", { staticClass: "explan-text" }, [
        _vm._v(
          "如果员工出现随意绑定或解绑客户档案情况，您可以选择开启此审批。开启后作用于全企业。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "options-explain" }, [
      _c("span", { staticClass: "explan-text" }, [
        _vm._v("将宏脉系统标签和企微标签基础数据双向同步，达到标签统一的效果。")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }